import moment from 'moment';
import 'antd/dist/antd.css';
import HostFooter from './HostFooter';
import { Modal, Popover, notification, Button, Radio } from 'antd';
import { push } from 'connected-react-router';
import React, { useState, useEffect } from 'react';
import edit from '../../assets/images/host/edit.svg';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Cell, DialogContainer } from 'react-md';
import { getvaluesfromURL } from '../../helper/Filter';
import OpenedDatepicker from './Modals/OpenedDatePicker';
import { CREATE, EDIT, MANUAL_BOOKING } from '../Common/constants';
import deleteIcon from '../../assets/images/host/delete.svg';
import ellipsis from '../../assets/images/host/ellipsis.svg';
import building from '../../assets/images/common/building.svg';
import arrow from '../../assets/images/common/black-arrow.svg';
import calendar from '../../assets/images/host/calendar-grey.svg';
import dropdownIcon from '../../assets/images/common/dropdown.svg';
import syncImg from '../../assets/images/space-listing/sync.png';
import downIcon from '../../assets/images/space-listing/downIcon.png';
import deleteBin from '../../assets/images/space-listing/delete-warn.png';
import time from '../../assets/images/host/time.svg';
import google from '../../assets/images/space-listing/google.png';
import synced from '../../assets/images/calendarSync/synced.svg';
import useWindowDimensions from '../Common/Hooks/useWindowDimensions';
import CreateReservationWorkModal from './Modals/CreateReservationWorkModal';
import CreateReservationMeetModal from './Modals/CreateReservationMeetModal';
import { CALENDER_DISPLAY_DATE_FORMAT, CALENDER_DATE_FORMAT, IMAGES_BASE_URL, scopes, updated_scopes, updated_client_id, REDIRECT_URL } from '../../settings';
import {
  fetchSpaceDetails,
  getCalenderData,
  createReservation,
  sendBookingCancellation,
  fetchSelectedBooking,
  updateReservation,
  getCalenderList,
  checkUserAuthorization,
  calendarAddToSpace,
  getLoggedUserStatus,
  removeGoogleCalenderFromSpace,
  setSelectedCalendar,
} from './HostDashboardActions';
import { CLEAR_SPACE_AVAILABILITY } from './HostDashboardActionTypes';
import { redClose } from '../BookingCancelation/BookingCancellationAssets';
import { endDate, startDate } from '../../helper/HostDashboardHelper';
import { useParams } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import { showErrorMessageCalendar, showSuccessMessageCalendar } from '../SpaceListing/Common/Common';

const SCOPES = updated_scopes;
const CLIENT_ID = updated_client_id;
const REDIRECT_URI = REDIRECT_URL;

const Calendar = () => {
  const [visibleModel, setHelpAndSupportVisible] = useState(false);
  const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
  const [isAssignModalVisible, setIsAssignModalVisible] = useState(false);
  const [isUnLinkModalVisible, setIsUnlinkModalVisible] = useState(false);
  const [isGoogleModalVisible, setIsGoogleModalVisible] = useState(false);
  const dispatch = useDispatch();
  const dimensions = useWindowDimensions();
  const searchURLstring = useSelector((state) => state?.router?.location?.search || '');
  const authStatus = useSelector((state) => state?.hostDashboard?.calendar?.authStatus || []);
  const calendarListObj = useSelector((state) => state?.hostDashboard?.calendar?.calendarList || []);
  const calendarList = Object.values(calendarListObj);
  const { spaceId, status } = getvaluesfromURL(searchURLstring);
  const calenderData = useSelector((state) => state?.hostDashboard?.data?.calenderData?.bookings || []);
  const spaceDetails = useSelector((state) => state?.hostDashboard?.data?.spaceDetails || []);
  const selectedSpaceDetails = useSelector((state) => state?.hostDashboard?.data?.spaceDetails || null);
  const createReservationStatus = useSelector((state) => state?.hostDashboard?.data?.createReservation || null);
  const cancelReservationStatus = useSelector((state) => state?.hostDashboard?.data?.cancelReservation || null);
  const updateReservationStatus = useSelector((state) => state?.hostDashboard?.data?.updateReservation || null);
  const category = useSelector(
    (state) =>
      state?.hostDashboard?.data?.spaceDetails?.events &&
      state?.hostDashboard?.data?.spaceDetails?.events.length &&
      state?.hostDashboard?.data?.spaceDetails?.events[0].eventType.spaceCategory.name
  );
  const [createReservationWorkVisibility, setCreateReservationWorkVisibility] = useState(false);
  const [createReservationMeetVisibility, setCreateReservationMeetVisibility] = useState(false);
  const [bookingsForTheDate, setBookingsForTheDate] = useState([]);
  const [cancelPopupVisibility, setCancelPopupVisibility] = useState(false);
  const [popOverVisibility, setPopOverVisibility] = useState([]);
  const [deleteBookingId, setDeleteBookingId] = useState(null);
  const [popupType, setPopupType] = useState('');
  const selectedSpace = useSelector((state) => state?.hostDashboard?.data?.selectedSpaceData || []);
  const errorMessage = useSelector((state) => state?.hostDashboard?.error);
  const [selectedDate, setSelectedDate] = useState(moment());
  const mobileView = dimensions.width < 992;
  const [displayEditBlock, setEditBlockStatus] = useState(false);
  const authToken = useSelector((state) => state?.auth?.loginDetails?.data?.token || []);
  const [showButton, setButtonActive] = useState(true);
  const { country } = useParams();
  // const [selectedCalendar, setSelectedCalendar] = useState(null);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const currentCalendar = calendarList.find((calendar) => calendar.spaceId === spaceId);
  const selectedCalendar = useSelector((state) => state.hostDashboard?.calendar?.selectedCalendar || null);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: authToken,
  };

  const handleCalendarSelect = (e) => {
    dispatch(setSelectedCalendar(e.target.value));
  };

  const updateSelectedCalender = () => {
    const selected = calendarList.find((calendar) => calendar.spaceId === spaceId);
    if (selected) {
      dispatch(setSelectedCalendar(selected.calendarId));
    }
  };

  // useEffect(() => {
  //   updateSelectedCalender();
  // }, []);

  const showSyncModal = () => {
    if (authStatus?.status) {
      setIsSaveModalVisible(true);
      dispatch(getCalenderList());
      updateSelectedCalender();
    } else {
      setPopoverVisible(true);
    }
  };
  const handleUnlinkOk = () => {
    dispatch(
      removeGoogleCalenderFromSpace(spaceId, (success) => {
        if (success) {
          dispatch(getCalenderList());
          dispatch(setSelectedCalendar(null));
          setIsUnlinkModalVisible(false);
          showSuccessMessageCalendar('Calendar Unlinked Successfully!')
        } else {
          showErrorMessageCalendar('Unlink Calendar UnSuccessFull!');
        }
      })
    );
  };

  const handleUnlinkCancel = () => {
    setIsUnlinkModalVisible(false);
  };

  const handleAssignedOk = () => {
    const payload = {
      spaceId: spaceId,
      calendarId: selectedCalendar,
      isActive: true,
      authTokenMapId: authStatus?.authTokenMapId,
    };

    dispatch(
      calendarAddToSpace(payload, (success) => {
        if (success) {
          dispatch(getCalenderList());
          setIsAssignModalVisible(false);
          setIsSaveModalVisible(false);
          showSuccessMessageCalendar('Calendar Assigned Successfully!')
        } else {
          showErrorMessageCalendar('Please Remove the Previous Calendar Before Adding a New Calendar.');
        }
      })
    );
  };

  const handleAssignCancel = () => {
    setIsAssignModalVisible(false);
  };

  useEffect(() => {
    dispatch(fetchSpaceDetails(spaceId));
    dispatch(checkUserAuthorization());
    const currentDate = moment().format('DD-MM-YYYY');
    Object.entries(calenderData).forEach(([key, value]) => {
      if (key === currentDate) {
        if (value.length) {
          setBookingsForTheDate(value);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (authStatus?.status) {
      dispatch(getCalenderList());
    }
  }, [authStatus?.status, dispatch]);

  useEffect(() => {
    bookingsForTheDate.length &&
      bookingsForTheDate.forEach((booking) => {
        popOverVisibility.push(false);
      });
  }, [bookingsForTheDate]);

  useEffect(() => {
    const startMonth = moment().startOf('month').format(CALENDER_DATE_FORMAT);
    const endMonth = moment().add(3, 'months').format(CALENDER_DATE_FORMAT);
    const payload = {
      startDate: startMonth,
      endDate: endMonth,
    };
    try {
      if (authToken) {
        dispatch(
          getCalenderData(spaceId, payload, headers, (success, data) => {
            if (success) {
              const currentDate = moment(selectedDate).format('DD-MM-YYYY');
              let bookingDateFound = false;
              Object.entries(calenderData).forEach(([key, value]) => {
                if (key === currentDate) {
                  bookingDateFound = true;
                  if (value.length) {
                    setBookingsForTheDate(value);
                  } else {
                    setBookingsForTheDate([]);
                  }
                }
              });
              if (!bookingDateFound) {
                setBookingsForTheDate([]);
              }
            }
          }))
      }
    } catch (error) {
      throw error
    }
  }, [selectedDate, authToken, createReservationStatus, updateReservationStatus, cancelReservationStatus]);

  const handleCreateReservation = () => {
    setPopupType(CREATE);
    if (category === 'Work') {
      setCreateReservationWorkVisibility(true);
    } else {
      setCreateReservationMeetVisibility(true);
    }
  };

  const handleModalCancel = () => {
    setCreateReservationWorkVisibility(false);
    setCreateReservationMeetVisibility(false);
    dispatch({ type: CLEAR_SPACE_AVAILABILITY });
  };

  const handleProceedReservation = (payload) => {
    if (popupType === CREATE) {
      dispatch(createReservation(payload, headers));
    } else {
      const editingHeaders = {
        'Content-Type': 'application/json',
        Authorization: authToken,
        'If-Match': selectedSpace?.version || '',
      };
      dispatch(updateReservation(payload, editingHeaders));
    }
    setCreateReservationWorkVisibility(false);
    setCreateReservationMeetVisibility(false);
  };

  const handleBack = () => {
    const URLtoPush = `/${country}/dashboard/myspaces/${status}/${spaceId}`;
    dispatch(push(URLtoPush));
  };

  const handlePopoverVisibleChange = (index, visible) => {
    const visibilityArray = popOverVisibility;
    visibilityArray[index] = visible;
    setPopOverVisibility([...visibilityArray]);
  };

  const handleEditReservation = (id, index) => {
    setPopupType(EDIT);
    dispatch(fetchSelectedBooking(id, headers));
    const visibilityArray = popOverVisibility;
    visibilityArray[index] = false;
    setPopOverVisibility([...visibilityArray]);
  };

  const handleCancelReservation = (id, index) => {
    const visibilityArray = popOverVisibility;
    visibilityArray[index] = false;
    setPopOverVisibility([...visibilityArray]);
    setDeleteBookingId(id);
    dispatch(fetchSpaceDetails(spaceId));
    setCancelPopupVisibility(true);
  };

  const handleCancelReservationYes = () => {
    const payload = { id: deleteBookingId };
    dispatch(sendBookingCancellation(payload, headers));
    setCancelPopupVisibility(false);
  };

  const handleCancelReservationNo = () => {
    setCancelPopupVisibility(false);
  };

  const handleReservation = (bookingId, index) => {
    handleEditReservation(bookingId, index);
    setEditBlockStatus(true);
  };

  const content = (booking, index) => {
    return (
      <div className="reservation-popover">
        <span className="list-items" onClick={() => handleReservation(booking.id, index)}>
          <img src={edit} alt="img" className="icon" />
          Edit reservation
        </span>
        <span className="list-items cancel" onClick={() => handleCancelReservation(booking.id, index)}>
          <img src={deleteIcon} alt="img" className="icon" />
          Cancel reservation
        </span>
      </div>
    );
  };

  useEffect(() => {
    if (selectedSpace.length !== 0 && displayEditBlock) {
      if (category === 'Work') {
        setCreateReservationWorkVisibility(true);
      } else {
        setCreateReservationMeetVisibility(true);
      }
    }
  }, [selectedSpace]);

  const handleEnteredBookingData = () => {
    if (popupType === EDIT) {
      return {
        startingDate: selectedSpace?.bookingStartDate || '',
        endingDate: selectedSpace?.bookingEndDate || '',
        firstName: selectedSpace?.reservationDetails?.firstName || '',
        lastName: selectedSpace?.reservationDetails?.lastName || '',
        email: selectedSpace?.reservationDetails?.email || '',
        contact: selectedSpace?.reservationDetails?.contactNumber || '',
        title: selectedSpace?.title || '',
        description: selectedSpace?.description || '',
        guestCount: selectedSpace?.guest || 0,
        seatingArrangement: selectedSpace?.seatArrangement?.name || '',
        startTime: selectedSpace?.pricingOptions?.[0]?.startTime || '',
        endTime: selectedSpace?.pricingOptions?.[0]?.endTime || '',
        blocks: selectedSpace?.pricingOptions || [],
      };
    } else {
      return {
        startingDate: '',
        endingDate: '',
        firstName: '',
        lastName: '',
        email: '',
        contact: '',
        title: '',
        description: '',
        guestCount: 1,
        seatingArrangement: '',
        startTime: '',
        endTime: '',
        blocks: [],
      };
    }
  };

  useEffect(() => {
    if (errorMessage) {
      notification.open({
        className: 'booking-cancellation-notification',
        message: (
          <span className="title">
            {' '}
            <img src={redClose} alt="arrow" className="icon" /> <span className="text">{'Error occurred!'}</span>
          </span>
        ),
      });
    }
  }, [errorMessage]);

  const handleBackToCurrentDate = () => {
    const currentDate = moment().format('YYYY-MM-DD');
    setSelectedDate(moment(currentDate));
  };

  useEffect(() => {
    const selected = moment(selectedDate).format('YYYY-MM-DD');
    const isInBetween = moment(selected).isBetween(moment(endDate), moment(startDate));
    if (isInBetween) setButtonActive(true);
    else setButtonActive(false);
  }, [selectedDate]);

  const responseGoogle = (response) => {
    if (response.code) {
      const payload = {
        code : response?.code
      }
      dispatch(
        getLoggedUserStatus(payload, (success, res) => {
          if (success) {
            dispatch(getCalenderList());
            dispatch(checkUserAuthorization());
            setPopoverVisible(false);
            setIsSaveModalVisible(true);
            showSuccessMessageCalendar('Calendar Synced Successfully!')
          } else {
            showErrorMessageCalendar(res.data ? res.data : 'Calendar Sync Unsuccessful!');
          }
        })
      );
    }
  };

  const responseError = (error) => {
    showErrorMessageCalendar('Calendar Sync Unsuccessful!')
  };

  return (
    <>
      <div className="my-calendar host-dashboard">
        <div className="header">
          <div className="container custom-container flex-wrap">
            <div className="left">
              <img src={arrow} alt="arrow" onClick={handleBack} className="arrow-img" />
              <h2 className="title">{spaceDetails.spaceName}</h2>
            </div>

            <div className="right flex-row-calandar no-flex-wrap">
              <button
                onClick={() => showSyncModal()}
                className={`goglesync-btn ${authStatus?.status ? 'goglesync-btn-green' : 'goglesync-btn-gray'}`}
              >
                {authStatus?.status ? <img src={synced} alt="arrow" className="sync-img" /> : <img src={syncImg} alt="arrow" className="sync-img" />}
                Calendar Sync
                <img src={downIcon} alt="arrow" className="down-img" />
              </button>
              <button className="btn-yellow btn-reservation" onClick={handleCreateReservation}>
                Create reservation
              </button>
            </div>
          </div>
        </div>
        <div className="content scrollwrap">
          <div className="mobile-only">
            <OpenedDatepicker data={calenderData} setSelectedDate={setSelectedDate} selectedDate={selectedDate} />
            <img src={dropdownIcon} alt="img" className="img calendar-dropdown-icon" />
          </div>
          <div className="container custom-container">
            <Grid className="calendar-grid">
              <Cell size={5} tabletSize={4} phoneHidden className="spacy-left">
                <OpenedDatepicker data={calenderData} setSelectedDate={setSelectedDate} selectedDate={selectedDate} />
              </Cell>
              <Cell size={7} tabletSize={4} phoneSize={12} className="spacy-right">
                <div className="card-list">
                  {bookingsForTheDate.length ? (
                    bookingsForTheDate.map((booking, index) => {
                      return (
                        <div className="card">
                          <span className="img" style={{ backgroundImage: `url(${booking?.image})` }}></span>
                          <div className="content">
                            {booking?.platformIdentity === MANUAL_BOOKING ? (
                              <span className="title">{booking?.title}</span>
                            ) : (
                              <span className="title">{booking?.guest}</span>
                            )}
                            <span className="sub-title">via {booking?.platform} </span>
                            <div className="flex-wrap">
                              <div className="date-block">
                                <span className="date">
                                  <img src={booking?.blocks[0]?.startTime ? time : calendar} alt="img" className="calendar-img" />
                                  {moment(booking?.bookingStartDate, CALENDER_DATE_FORMAT).format(CALENDER_DISPLAY_DATE_FORMAT)}-
                                  {moment(booking?.bookingEndDate, CALENDER_DATE_FORMAT).format(CALENDER_DISPLAY_DATE_FORMAT)}
                                </span>

                                {booking?.blocks[0]?.startTime &&
                                  booking?.blocks.map((item) => {
                                    return (
                                      <span className="time">
                                        {item?.startTime || 'N/A'} - {item?.endTime || 'N/A'}
                                      </span>
                                    );
                                  })}
                              </div>

                              {booking?.platformIdentity === MANUAL_BOOKING && (
                                <div className="space-popover-wrap">
                                  <Popover
                                    placement="bottom"
                                    content={content(booking, index)}
                                    trigger="click"
                                    visible={popOverVisibility[index]}
                                    onVisibleChange={(visible) => handlePopoverVisibleChange(index, visible)}
                                    overlayClassName="space-popover"
                                  >
                                    <img src={ellipsis} alt="img" className="ellipsis-img" />
                                  </Popover>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-more-wrap">
                      <img alt="img" className="img" src={building} />
                      <p className="title">No Results Found</p>
                      <p className="sub-title">
                        Sorry! We can't seem to find any bookings that match your search. <br />
                        Please try a different date.
                      </p>
                      <button className="btn btn-outline" onClick={() => dispatch(push(`/${country}/help`))}>
                        Contact us
                      </button>
                    </div>
                  )}
                </div>
              </Cell>
              <button className="btn btn-outline btn-back-to-today" hidden={showButton} onClick={handleBackToCurrentDate}>
                Back To Today
              </button>
            </Grid>
          </div>
        </div>
        <Modal
          className="host-dashboard-modal create-reservation-modal"
          visible={createReservationWorkVisibility}
          onCancel={handleModalCancel}
          footer={null}
          destroyOnClose={true}
        >
          <CreateReservationWorkModal
            setVisible={setCreateReservationWorkVisibility}
            space={spaceDetails}
            onProceed={handleProceedReservation}
            selectedSpaceDetails={selectedSpaceDetails}
            blockType={popupType}
            previousBookingData={handleEnteredBookingData()}
            selectedDateOnCalender={selectedDate}
            category={category}
          />
        </Modal>
        <Modal
          className="host-dashboard-modal create-reservation-modal"
          visible={createReservationMeetVisibility}
          onCancel={handleModalCancel}
          footer={null}
          destroyOnClose={true}
        >
          <CreateReservationMeetModal
            setVisible={setCreateReservationMeetVisibility}
            onProceed={handleProceedReservation}
            space={spaceDetails}
            selectedSpaceDetails={selectedSpaceDetails}
            blockType={popupType}
            previousBookingData={handleEnteredBookingData()}
            selectedDateOnCalender={selectedDate}
            category={category}
          />
        </Modal>

         <Modal
          centered
          title={
            <div className="header-container-calnder">
              <div className="google-container">
                <div>
                  <img alt="img" className="img-google" src={google} />
                </div>

                <div className="google-container-col">
                  <p className="google-text">Google Calendar</p>
                  <a className= {`authorized-text ${!(currentCalendar && selectedCalendar === currentCalendar.calendarId) ? 'disabled' : ''}`}  onClick={() => setIsUnlinkModalVisible(true)}>Unlink calendar from the space</a>
                 
                </div>
              </div>
            
            </div>
          }
          // wrapClassName="custom-ant-space-modal-calandar"  // this style for sync modal and  custom-ant-space-modal-calandar this is common style for botth sync and async modl and if async true custom-ant-space-modal-calandar-resync this style should be apply
          wrapClassName=' custom-ant-space-modal-calandar '//this style for async modl
          visible={isSaveModalVisible}
          onCancel={() => setIsSaveModalVisible(false)}
          footer={[
            <Button key="cancel" 
            onClick={() => setIsSaveModalVisible(false)} 
            className="custom-cancel-button-assign">
              CANCEL
            </Button>,
            <Button
              key="ok"
              onOk={() => setIsSaveModalVisible(false)}
              className="assign-button assign-btn-async"
              onClick={() => setIsAssignModalVisible(true)}
              disabled={!selectedCalendar || (currentCalendar && selectedCalendar === currentCalendar.calendarId)}
              style={{ opacity: !selectedCalendar || (currentCalendar && selectedCalendar === currentCalendar.calendarId) ? 0.5 : 1 }}
            >
              ASSIGN TO THIS SPACE
            </Button>,
          ]}
        >
          <Radio.Group onChange={handleCalendarSelect} value={selectedCalendar} className="radio-group">
            {calendarList
              .filter((calendar) => calendar.spaceId === null || calendar.spaceId === spaceId)
              .map((calendar) => (
                <Radio key={calendar.calendarId} value={calendar.calendarId} className="radio-item">
                 <span >{calendar.name}</span> 
                </Radio>
              ))}
          </Radio.Group>
         
        </Modal> 

      

        <Modal
          wrapClassName="custom-ant-space-modal-calandar-google"
          visible={popoverVisible}
          footer={null}
          maskClosable={true}
          onCancel={() => setPopoverVisible(false)}
        >
          <GoogleLogin
            clientId={CLIENT_ID}
            render={(btnGoogleEnable) => (
              <button className="btn calendar-btn-google" onClick={btnGoogleEnable.onClick}>
                <img src={google} alt="Google" style={{ width: '24px', marginRight: '10px' }} />
                <span className="sync-text">Sync Google Calendar</span>
              </button>
            )}
            buttonText="Login"
            onSuccess={responseGoogle}
            onFailure={responseError}
            // cookiePolicy={'single_host_origin'}
            responseType="code"
            accessType="offline"
            prompt="consent"
            scope={SCOPES}
            // uxMode={'redirect'}
            redirectUri={REDIRECT_URI}
          />
        </Modal>

        <Modal
          title="Assign Calendar?"
          wrapClassName="custom-ant-space-modal-assign"
          visible={isAssignModalVisible}
          onOk={handleAssignedOk}
          onCancel={handleAssignCancel}
          okText="ASSIGN"
          cancelText="CANCEL"
          centered
          cancelButtonProps={{ className: 'custom-cancel-button-assign' }}
        >
          <p className="modal-text-save-head">Are you sure you want to assign this calendar to this space?</p>
        </Modal>

        <Modal
          title="Unlink Calendar?"
          wrapClassName="custom-ant-space-modal-assign"
          visible={isUnLinkModalVisible}
          onOk={handleUnlinkOk}
          onCancel={handleUnlinkCancel}
          okText="UNLINK"
          cancelText="CANCEL"
          centered
          cancelButtonProps={{ className: 'custom-cancel-button-assign' }}
        >
          <p className="modal-text-save-head custom-modal-text">
            Are you sure you want to unlink your Google Calendar from <span>{spaceDetails.spaceName}.</span>
            <span> </span>This will stop event synchronization?
          </p>
        </Modal>
      </div>

      <DialogContainer className="cancel-reservation-modal" visible={cancelPopupVisibility} focusOnMount={false}>
        <>
          <div className="content">
            <p className="title">Cancel Reservation?</p>
            <p className="sub-title">Are you sure you want to cancel the reservation?</p>
          </div>
          <div className="footer">
            <button className="btn btn-no" onClick={handleCancelReservationNo}>
              NO
            </button>
            <button className="btn btn-yes" onClick={handleCancelReservationYes}>
              YES
            </button>
          </div>
        </>
      </DialogContainer>
      {mobileView && <HostFooter />}
    </>
  );
};

export default Calendar;
